module.exports = __webpack_public_path__ + "static/img/support-bear.1632b89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/downgrade/images/support-bear.svg
// module id = qZ62
// module chunks = 12